var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M22 0.978027C22.5 3.47803 25.3 8.57803 32.5 8.97803",
    stroke: "#25232C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M22.4903 17.0761C22.4361 17.3469 22.1727 17.5225 21.9019 17.4683C21.6312 17.4142 21.4556 17.1507 21.5097 16.88L22.4903 17.0761ZM21.5097 16.88C22.0435 14.2109 24.9935 8.89428 32.4723 8.4788L32.5277 9.47726C25.6065 9.86177 22.9565 14.7451 22.4903 17.0761L21.5097 16.88Z",
    fill: "#25232C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M1 8.47803C0.723858 8.47803 0.5 8.70188 0.5 8.97803C0.5 9.25417 0.723858 9.47803 1 9.47803V8.47803ZM32.5 8.47803L1 8.47803V9.47803L32.5 9.47803V8.47803Z",
    fill: "#25232C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.25714e9593ad44fe73170c2c379beaef.svg";
export { ForwardRef as ReactComponent };